// extracted by mini-css-extract-plugin
module.exports = {"root":"MaskedId_root__1lSgD","text":"MaskedId_text__JlIGo"};